import {
    Tooltip,
    Box
  } from '@mui/material';
  import {  VisibilityOutlined as VisibilityOutlinedIcon, WhatsApp as WhatsAppIcon, Phone as PhoneIcon, Email as EmailIcon } from '@mui/icons-material';
  
  import React from 'react';

const ProductStats = ({product}) => {   
    return (
        <Box sx={{display:'flex', gap: {xs:'0.5rem', md:'2rem'},
         flexDirection:'row', 
        justifyContent:'space-between',
         alignItems:'center',
         px: {xs:'1rem', md:'1rem'}}} >
<Tooltip title={`Publicación visualizada ${product.views} ${product.views === 1 ? 'vez' : 'veces'}`}>
<VisibilityOutlinedIcon sx={{ mr: 0.5, fontSize: {xs:'0.8rem', md:'1.2rem'} }} />
{product.views}
</Tooltip>

<Tooltip title={`WhatsApp abierto ${product.contactStats.messageClicks} ${product.contactStats.messageClicks === 1 ? 'vez' : 'veces'}`}>
<WhatsAppIcon sx={{ mr: 0.5, fontSize: {xs:'0.8rem', md:'1.2rem'} }} />
{product.contactStats.messageClicks}
</Tooltip>


<Tooltip title={
`Número copiado ${product.contactStats.numberCopyClicks} ${product.contactStats.numberCopyClicks === 1 ? 'vez' : 'veces'} |
Número llamado ${product.contactStats.callClicks} ${product.contactStats.callClicks === 1 ? 'vez' : 'veces'}`}>
<PhoneIcon sx={{ mr: 0.5, fontSize: {xs:'0.8rem', md:'1.2rem'} }} />
{product.contactStats.numberCopyClicks} | {product.contactStats.callClicks}
</Tooltip>

<Tooltip title={`Email copiado ${product.contactStats.emailCopyClicks} ${product.contactStats.emailCopyClicks === 1 ? 'vez' : 'veces'}`}>
<EmailIcon sx={{ mr: 0.5, fontSize: {xs:'0.8rem', md:'1.2rem'} }} />
{product.contactStats.emailCopyClicks}
</Tooltip>
</Box>
    );
}

export default ProductStats;